import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import InstallAppButton from "./InstallAppButton";

const Footer = () => (
  <footer className="bg-[#0A0A0A] border-t border-white/5 py-16">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
        <div>
          <img
            src="https://customer-assets.emergentagent.com/job_3ae66389-b093-4330-9743-6c6a00dc5113/artifacts/2iyfs3ge_ChatGPT%20Image%20Dec%2022%2C%202025%2C%2012_56_32%20PM%20-%20Copy.png"
            alt="Cut Above Polish Shop"
            className="h-20 w-auto mb-4"
          />
          <p className="text-gray-400 text-sm leading-relaxed">Premium automotive detailing and metal polishing supplies. Quality products trusted by professionals.</p>
        </div>
        <div>
          <h4 className="font-heading text-lg mb-4 tracking-wide">SHOP</h4>
          <ul className="space-y-2">
            <li><Link to="/products?category=Buffing Wheels" className="text-gray-400 hover:text-white text-sm transition-colors">Buffing Wheels</Link></li>
            <li><Link to="/products?category=Compounds" className="text-gray-400 hover:text-white text-sm transition-colors">Compounds</Link></li>
            <li><Link to="/products?category=Kits" className="text-gray-400 hover:text-white text-sm transition-colors">Kits</Link></li>
            <li><Link to="/products?category=Polishers" className="text-gray-400 hover:text-white text-sm transition-colors">Polishers</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading text-lg mb-4 tracking-wide">LEARN</h4>
          <ul className="space-y-2">
            <li><Link to="/university" className="text-gray-400 hover:text-white text-sm transition-colors">Polishing University</Link></li>
            <li><Link to="/affiliates" className="text-gray-400 hover:text-white text-sm transition-colors">Affiliates</Link></li>
            <li><Link to="/vip" className="text-gray-400 hover:text-white text-sm transition-colors">VIP Membership</Link></li>
            <li><Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors">Contact Us</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading text-lg mb-4 tracking-wide">POLICIES</h4>
          <ul className="space-y-2">
            <li><Link to="/policies#shipping" className="text-gray-400 hover:text-white text-sm transition-colors">Shipping Policy</Link></li>
            <li><Link to="/policies#returns" className="text-gray-400 hover:text-white text-sm transition-colors">Returns & Refunds</Link></li>
            <li><Link to="/policies#privacy" className="text-gray-400 hover:text-white text-sm transition-colors">Privacy Policy</Link></li>
            <li><Link to="/policies#terms" className="text-gray-400 hover:text-white text-sm transition-colors">Terms of Service</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading text-lg mb-4 tracking-wide">CONTACT</h4>
          <ul className="space-y-3">
            <li className="flex items-center gap-2 text-gray-400 text-sm"><Phone className="w-4 h-4 text-[#D62828]" />352-808-8981</li>
            <li className="flex items-center gap-2 text-gray-400 text-sm"><Mail className="w-4 h-4 text-[#D62828]" />sales@cutabovepolishshop.store</li>
            <li className="text-gray-400 text-sm">Customer Service: Renee Daniels</li>
          </ul>
          <div className="mt-4 flex flex-wrap gap-3">
            <a href="https://www.facebook.com/profile.php?id=61585201404170" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full border border-white/15 text-gray-300 hover:text-white hover:border-white/40 transition-colors text-xs">FB</a>
            <a href="https://www.instagram.com/a_cut_above_polish_shop/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full border border-white/15 text-gray-300 hover:text-white hover:border-white/40 transition-colors text-xs">IG</a>
            <a href="https://www.tiktok.com/@cut.above.polish" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full border border-white/15 text-gray-300 hover:text-white hover:border-white/40 transition-colors text-xs">TT</a>
            <a href="https://x.com/cutabovepolish" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full border border-white/15 text-gray-300 hover:text-white hover:border-white/40 transition-colors text-xs">X</a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
        <p className="text-gray-500 text-sm">© 2025 Cut Above Polish Shop. All rights reserved.</p>
        <div className="flex items-center gap-3">
          <span className="text-gray-500 text-xs uppercase tracking-wide hidden sm:inline">Take us with you:</span>
          <InstallAppButton variant="primary" label="Install App" />
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
